import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MeModel } from '../models/me.model';

@Injectable()
export class MeService {

  constructor(
    private http: HttpClient,
    @Inject('API_BASE_URL') private baseUrl: string) { }

  get(): Promise<MeModel> {
    const url = this.baseUrl + 'me';

    let promise = new Promise<MeModel>((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(res => {
          var data = (res as MeModel);
          resolve(data);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: "Could not get user"
          });
        });
    });

    return promise;
  }

  update(model: any): Promise<MeModel> {
    const url = this.baseUrl + 'me';

    let promise = new Promise<MeModel>((resolve, reject) => {
      this.http.put(url, model)
        .toPromise()
        .then(res => {
          var data = (res as MeModel);
          resolve(data);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: reason.status == 404 ? reason.error : "Could not update user"
          });
        });
    });

    return promise;
  }
}
